import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { audit, interval, Observable, throwError } from 'rxjs';
import { AuthService } from '@app/auth/auth.service';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	baseUrl: string;

	constructor(private httpClient: HttpClient, private authService: AuthService) {
		this.baseUrl = environment.baseUrl;
	}

	public getBaseUrl() {
		return this.baseUrl;
	}

	public async get(url): Promise<any> {
		try {
			const result = await this.httpClient
				.get(`${this.baseUrl}/${url}`, {
					// headers: this.getAuthHeader(),
				})
				.toPromise();
			//console.log('Retrieved data for GET ' + url); // '-> ' + JSON.stringify(result)
			return result;
		} catch (e) {
			 if (e && e.status && e.status === 401) {
			   this.serverReturnedUnauthorized();
			}
			console.error('Error during GET ' + url + '-> ', e);
			throw e;
		}
	}

	public async post(url, item): Promise<any> {
		try {
			const result = await this.httpClient
				.post(`${this.baseUrl}/${url}`, item, {
					// headers: this.getAuthHeader(),
				})
				.toPromise();
			//console.log('Retrieved data for POST ' + url); // '-> ' + JSON.stringify(result)
			return result;
		} catch (e) {
			if (e && e.status && e.status === 401) {
			 	this.serverReturnedUnauthorized();
			}
			console.error('Error during POST ' + url + '-> ', e);
			throw e;
		} finally {
		}
	}

	public postStreamed(url, item): Observable<any> {
		return this.httpClient
			.post(`${this.baseUrl}/${url}`, item, {
				observe: 'events',
				responseType: 'text',
				reportProgress: true,
			})
			.pipe(
				audit(() => interval(100)),
				catchError((error) => {
					if (error.status === 401) {
						this.serverReturnedUnauthorized();
					}
					return throwError(() => error);
				})
			);
	}

	public async put(url, item): Promise<any> {
		try {
			const result = await this.httpClient
				.put(`${this.baseUrl}/${url}`, item, {
					// headers: this.getAuthHeader(),
				})
				.toPromise();
			//console.log('Retrieved data for PUT ' + url); // '-> ' + JSON.stringify(result)
			return result;
		} catch (e) {
			if (e && e.status && e.status === 401) {
			  this.serverReturnedUnauthorized();
			}
			console.error('Error during PUT ' + url + '-> ', e);
			throw e;
		} finally {
		}
	}

	public async delete(url) {
		try {
			const result = await this.httpClient
				.delete(`${this.baseUrl}/${url}`, {
					// headers: this.getAuthHeader(),
				})
				.toPromise();
			//console.log('Retrieved data for DELETE ' + url); // '-> ' + JSON.stringify(result)
			return result;
		} catch (e) {
			 if (e && e.status && e.status === 401) {
			  this.serverReturnedUnauthorized();
			}
			console.error('Error during DELETE ' + url + '-> ', e);
			throw e;
		} finally {
		}
	}

	private serverReturnedUnauthorized() {
    this.authService.login();
  }
}
